import { Report59Component } from "../../../components/SupportSystem/Reports/Report59Component";
// import { NavbarComponent } from "../../../components/share/NavbarComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";


export function Report59Container() {
    const titleName = "แบบรายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนแก่ศูนย์ประเมินความรู้ความสามารถกลาง";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <Report59Component/>
            <Footer />
        </div>   
        // 
    )
    
}